// extracted by mini-css-extract-plugin
export default {"rates":"Rates_rates__vLt2t","title":"Rates_title__84aUG","row":"Rates_row__tZO5H","blink":"Rates_blink__pKxxE"};